import { StorageLocalService } from './../../cache/storage-local.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';

/** @title Responsive sidenav */
@Component({
  selector: 'app-full-layout',
  templateUrl: 'full.component.html',
  styleUrls: []
})
export class FullComponent implements OnInit, OnDestroy {

  mobileQuery: MediaQueryList;
  usuario;

  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public rotas: Router,
    private _token: StorageLocalService
  ) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    this.usuario = JSON.parse(this._token.getUsuario());
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  retiraMenu() {
    if (this.rotas.url == '/pensao' || this.rotas.url == '/solicitacao' || this.rotas.url == '/faq' ||
    this.rotas.url == '/nova-senha' || this.rotas.url == '/validacao-email' || this.rotas.url.indexOf('/validacao') != -1) {
      return false;
    }
    return true;
  }

  deslogar() {
    this._token.limparToken();
    this.rotas.navigate(['/login']);
  }
}
